import { KioskIntegration } from '@inter-ikea-gallery/integration'

function createKioskIntegration() {
  try {
    return new KioskIntegration({ debug: import.meta.env.DEV })
  } catch {
    // KioskIntegration throws when running outside an IKEA iframe (e.g. standalone, tests)
    // due to cross-origin access to window.ikea. Return a no-op proxy so the app still works.
    console.error(
      'KioskIntegration initialization failed, returning no-op proxy. Error may be due to running outside of IKEA iframe.',
      {
        error: new Error('KioskIntegration initialization failed'),
      },
    )
    return new Proxy({} as KioskIntegration, {
      get: () => () => undefined,
    })
  }
}

export const kioskIntegration = createKioskIntegration()
